import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import ModernServices from '../components/ModernServices';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const ModernHome = () => {
  const [activeSection, setActiveSection] = useState('home');
  const location = useLocation();

  // Update active section based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'services', 'about', 'contact'];
      const scrollPosition = window.scrollY + 100; // Offset for header

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const requestedSection = location.hash.slice(1);
    if (!requestedSection) return;
    if (requestedSection === 'main-content') return;
    const allowedSections = ['home', 'services', 'about', 'contact'];
    if (!allowedSections.includes(requestedSection)) return;
    const sectionId = requestedSection;

    const frame = requestAnimationFrame(() => {
      const element = document.getElementById(sectionId);
      if (!element) return;
      setActiveSection(sectionId);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      element.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      element.focus({ preventScroll: true });
    });

    return () => cancelAnimationFrame(frame);
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-white dark:bg-dark-900">
      <Header activeSection={activeSection} />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <ModernServices />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default ModernHome;
